import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { TranslateModule } from '@ngx-translate/core'

// Core UI Components that are used across multiple modules
import { RowComponent } from './components/row/row.component'
import { CellComponent } from './components/cell/cell.component'
import { ContainerComponent } from './components/container/container.component'
import { PopoverComponent } from './components/popover/popover.component'
import { AlertComponent } from './components/alert/alert.component'
import { ConfirmComponent } from './components/confirm/confirm.component'

// Core PrimeNG - only the most essential components
import { CorePrimeNGModule } from './core-primeng.module'

/**
 * Core UI module that provides basic, commonly used components.
 * This should be imported by modules that need basic UI functionality.
 * For specific functionality, import FormsPrimeNGModule, DataPrimeNGModule, etc.
 */
@NgModule({
  declarations: [RowComponent, CellComponent, ContainerComponent, PopoverComponent, AlertComponent, ConfirmComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, CorePrimeNGModule],
  exports: [
    // Components
    RowComponent,
    CellComponent,
    ContainerComponent,
    PopoverComponent,
    AlertComponent,
    ConfirmComponent,
    // Modules
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    CorePrimeNGModule,
  ],
})
export class CoreUIModule {}
